import consumerApi from "api/services/consumer-api";
import { MenuItem } from "custom-types/MenuItem";
import logError from "utils/logError";

/*  
  An interface to the endpoint on consumer API:
  https://consumer-api-integration.internal.leafly.io/docs/api/1.0/menu_itemsv2menu_items/index.html
*/

export type MenuItemsV2MenuItems = {
  data: MenuItem[];
  metadata: {
    totalCount: number;
  };
};

const getMenuItemsByIds = async (ids: number[]) => {
  try {
    const { data } = await consumerApi.get<MenuItemsV2MenuItems>(
      `/api/menu_items/v2?${ids
        .map((id) => `filter[menu_item_id][]=${id}`)
        .join("&")}`,
    );

    return data;
  } catch (e) {
    logError(e.message, {
      functionName: "getMenuItemsByIds",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return {
      data: [],
      metadata: {
        totalCount: 0,
      },
    };
  }
};

export default getMenuItemsByIds;
